import './survey_timeseries_view.js.coffee'
Monitoring.Views.Charts ||= {}

class Monitoring.Views.Charts.SurveyResponsesTimeseriesView extends Monitoring.Views.Charts.SurveyTimeseriesView
  apiUrl: '/monitoring/api/charts/survey_responses/'
  name: 'survey_responses'
  chartOptions:
    colors: ['#1289a7']

  initialize: (@options = {}) ->
    @title = I18n.t('monitoring.dashboard.charts.survey_timeseries.responses')
    @title_en = I18n.t('monitoring.dashboard.charts.survey_timeseries.responses', {'locale': 'en'})
    super(@options)
